var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { propArrayShape, propFunc, propShape, propStr, } from '../../../helpers/custom-prop-types';
const PlainSelect = (props) => {
    const { className, input, meta, options, wrapOnChange } = props, others = __rest(props, ["className", "input", "meta", "options", "wrapOnChange"]);
    const onChange = useCallback((e) => {
        if (wrapOnChange) {
            wrapOnChange(e);
        }
        input.onChange(e);
    }, [input, wrapOnChange]);
    const warnClass = useMemo(() => (meta.touched && meta.error ? 'is-warning' : ''), [meta.touched, meta.error]);
    return (_jsx("select", Object.assign({}, input, { className: `${className} ${warnClass}`, onChange: onChange }, others, { children: options.map((option) => (_jsx("option", Object.assign({ value: option.value.toString() }, { children: option.label }), `${input.name}_${option.value}`))) })));
};
PlainSelect.propTypes = {
    className: propStr().isRequired,
    input: propShape().isRequired,
    meta: propShape().isRequired,
    options: propArrayShape().isRequired,
    wrapOnChange: propFunc(),
};
PlainSelect.defaultProps = {
    wrapOnChange: undefined,
};
export default PlainSelect;
